<template>
  <div></div>
</template>

<script>
import _ from 'lodash'
import { dcV2Graphql } from '@/api'
export default {
  props: {
    debug: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    desc: {
      type: String
    },
    imgUrl: {
      type: String
    }
  },
  created () {
    require.ensure([], () => {
      let wx = require('weixin-js-sdk')
      this.configure(wx)
      this.updateWx(wx)
    })
  },
  methods: {
    updateWx (wx) { this.$emit('updateWx', wx) },
    async configure (wx) {
      try {
        let shareUrl = window.location.href // 一定要用 href，因為微信分享簽名檢查的是當前網址。
        // https://github.com/nutspie/doc/blob/master/dartcome/pr-server-node/graphql/query.md
        let res = await dcV2Graphql.post('', {
          query: `query ($appId: String, $url: String) { weixinJsApiToken(appId: $appId, url: $url) {
            appId, nonceStr, signature, timestamp }
          }`,
          variables: {
            appId: 'wx778a481d4e07a603',
            url: shareUrl
          }
        })
        let data = _.get(res, 'data.data.weixinJsApiToken')
        if (!data) {
          throw new Error('fetch weixinJsApiToken failed')
        }
        let jsApiList = [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone'
        ]
        let config = {
          debug: this.debug,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList
        }
        wx.config(config)
        // http://qydev.weixin.qq.com/wiki/index.php?title=%E5%BE%AE%E4%BF%A1JS-SDK%E6%8E%A5%E5%8F%A3#.E5.88.86.E4.BA.AB.E6.8E.A5.E5.8F.A3
        wx.ready(() => {
          wx.onMenuShareTimeline({
            title: this.title,
            link: shareUrl,
            imgUrl: this.imgUrl,
            success: function () {
              // TODO send message to mixpanel
            },
            cancel: function () {
              // TODO send message to mixpanel
            }
          })
          wx.onMenuShareAppMessage({
            title: this.title,
            desc: this.desc,
            link: shareUrl,
            imgUrl: this.imgUrl,
            // type: '',
            // dataUrl: '',
            success: function () {
              // TODO send message to mixpanel
            },
            cancel: function () {
              // TODO send message to mixpanel
            }
          })
          wx.onMenuShareQQ({
            title: this.title,
            desc: this.desc,
            link: shareUrl,
            imgUrl: this.imgUrl,
            success: function () {
              // TODO send message to mixpanel
            },
            cancel: function () {
              // TODO send message to mixpanel
            }
          })
          wx.onMenuShareWeibo({
            title: this.title,
            desc: this.desc,
            link: shareUrl,
            imgUrl: this.imgUrl,
            success: function () {
              // TODO send message to mixpanel
            },
            cancel: function () {
              // TODO send message to mixpanel
            }
          })
          wx.onMenuShareQZone({
            title: this.title,
            desc: this.desc,
            link: shareUrl,
            imgUrl: this.imgUrl,
            success: function () {
              // TODO send message to mixpanel
            },
            cancel: function () {
              // TODO send message to mixpanel
            }
          })
        })
        wx.error(res => {
          // TODO send message to mixpanel
        })
      } catch (e) {
        console.error('configure e.message', e.message)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/wx.vue